import { render, staticRenderFns } from "./umsTable copy.vue?vue&type=template&id=0c71004a"
import script from "./umsTable copy.vue?vue&type=script&lang=js"
export * from "./umsTable copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports